module.exports = __webpack_public_path__ + "static/media/warez-logo.e6774ae6.png";